// CalendarWeek > CalendarWeek
import React from 'react'
import UxGrid from '../UxGrid'
import Scale from '../ScaleData'
import { columnNamesForThisWeek } from '../utils/Dates'
import { convertFrom24To12 } from '../utils/Time'
import { padZero } from '../utils/String'
import { CalendarWeekProps } from './index'

export const defaultProps = Object.freeze({
	use24: false
})

export default class CalendarWeek<T extends object> extends React.PureComponent<CalendarWeekProps<T>> {
	static readonly defaultProps = defaultProps

	labelConversion = (ix: number) => {
		const { use24 } = this.props

		let hour = ix / 2
		let min = 0
		let period = ''

		if (!use24) {
			const timeObj = convertFrom24To12(hour)

			hour = timeObj.hour
			min = timeObj.minute
			period = timeObj.period
		}

		const time = !use24
			? min > 0 ? `${hour}:${padZero(min)}${period.substring(0, 1)}` : `${hour}${period.substring(0, 1)}`
			: `${hour}:${padZero(min)}`

		return time
	}

	render() {
		const columnNames = columnNamesForThisWeek()

		return (
			<UxGrid<T>
				autoActivate={true}
				scale={new Scale(0, 48, 1)}
				columns={columnNames}
				labelConversion={this.labelConversion}
				{...this.props}
			/>
		)
	}
}
